export class OpenerSlate {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "OpenerSlate";
    this.scene = "MatchID";
    this.data = [];
  }

  async preview({ options }) {
    this.onAir = false;
    this.data = [];
    this.options = options;
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });
    this.data.push({
      name: "Home Team Name",
      value: {
        text: options?.game?.home_team?.name,
      },
    });
    this.data.push({
      name: "Home Team Short Name",
      value: {
        text: options?.game?.home_team?.short_name,
      },
    });
    this.data.push({
      name: "Home Team Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.home_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.third_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Name",
      value: {
        text: options?.game?.away_team?.name,
      },
    });
    this.data.push({
      name: "Away Team Short Name",
      value: {
        text: options?.game?.away_team?.short_name,
      },
    });
    this.data.push({
      name: "Away Team Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.away_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.third_badge || "",
      },
    });
    this.data.push({
      name: "Stadium",
      value: {
        text: options?.liveFrom,
      },
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
